import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setAuthRedirectPath } from "../store/userSlice";

function AuthRoute({ children }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const { isAuthenticated, authRedirectPath } = useSelector((state) => state.user);

  // Не перезаписываем authRedirectPath если он уже установлен
  // Сохраняем текущий путь только если пользователь НЕ на странице авторизации
  useEffect(() => {
    if (!authRedirectPath) {
      const authPaths = ["/authorization", "/registration", "/reset-password"];
      // Проверяем что пользователь НЕ на странице авторизации
      if (!authPaths.includes(location.pathname)) {
        dispatch(setAuthRedirectPath(location.pathname + location.search));
      }
    }
  }, [dispatch, location.pathname, location.search, authRedirectPath]);

  // Если пользователь аутентифицирован - просто рендерим children
  // Редирект после авторизации делается в Login.jsx и ConfirmEmail.jsx
  // НЕ делаем автоматический редирект на главную здесь,
  // потому что это перебивает navigate() из компонентов авторизации
  return children;
}

export default AuthRoute;
// AuthRoute.js